import { createStyles } from "src/styles/theme";

export type StylesClasses = keyof typeof styles;

/**
 * Shared metrics for the search-row toolbar so the search field, the state
 * filter and the action buttons all sit on the same baseline with the same
 * height and corner radius.
 */
export const TOOLBAR_CONTROL_HEIGHT = "44px";

export const toolbarFieldStyles = {
  height: TOOLBAR_CONTROL_HEIGHT,
  minHeight: TOOLBAR_CONTROL_HEIGHT,
  borderRadius: "8px",
  fontSize: "14px",
  boxShadow: "none",
  backgroundColor: "#FDFDFD",
  borderColor: "#D9D9D9",
};

export const toolbarButtonStyles = {
  height: TOOLBAR_CONTROL_HEIGHT,
  minWidth: "auto",
  padding: "0 20px",
  borderRadius: "8px",
  fontSize: "15px",
  fontWeight: 600,
  whiteSpace: "nowrap",
  boxShadow: "none",
};

const styles = createStyles({
  button: {
    width: "5%",
    border: "1px solid blue",
    margin: "1%",
    "&:hover": {
      backgroundColor: "blue",
      color: "white",
    },
  },
  flexContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  renderButtonText: {
    display: "block",
    textAlign: "left",
    fontSize: "17px",
  },
  renderButtonText2: {
    display: "block",
    textAlign: "left",
    fontSize: "18px",
    fontWeight: "600",
    color: "#36B1A0",
    textDecoration: "none",
  },
});

export default styles;
